// import { Clinic } from '../clinics/clinics.model';
import { ProfessionalDomicileAddress } from './member-professional-domicile.model';

export class LoadProfessionalDomiciles {
  constructor(public readonly memberId: string) { }
  static readonly type = '[MemberProfessionalDomiciles] LoadProfessionalDomiciles';
}
export class LoadProfessionalDomicilesSuccess {
  static readonly type = '[MemberProfessionalDomiciles] LoadProfessionalDomicilesSuccess';
  constructor(public readonly data: ProfessionalDomicileAddress[]) { }
}
export class LoadProfessionalDomicilesFailure {
  static readonly type = '[MemberProfessionalDomiciles] LoadProfessionalDomicilesFailure';
  constructor(public readonly error: any) { }
}
